<template>
  <tr
    class="table-tr-validation"
    :class="{ error: validationItter.error && validationItter.index == index }"
  >
    <td style="width: 5%">
      <button
        type="button"
        style="margin-top: 8px"
        :disabled="disabledDelete()"
        class="btn waves-effect waves-light mb-2"
        :class="classButton"
        @click="removeService"
      >
        <i class="fas fa-trash"></i>
      </button>
    </td>
    <td style="width: 25%">
      <div class="form-group mb-0">
        <select
          class="form-control select-2-custom-form"
          :disabled="loading"
          v-model="objectRetribution.id"
          v-select2
        >
          <option value="" selected disabled>
            --- Pilih Kategori Retribusi ----
          </option>
          <option
            :value="item.id"
            :data-name="item.name"
            v-for="item in dataService"
            :key="item.id"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
    </td>
    <td style="width: 25%">
      <div class="input-group mb-2">
        <input
          type="text"
          class="form-control"
          :readonly="!editablePrice"
          v-model="objectRetribution.price"
          v-currency="currencyMask"
          :disabled="loading"
        />
        <div class="input-group-prepend" v-if="objectRetribution.unit_type">
          <div class="input-group-text">
            / {{ objectRetribution.unit }}{{ objectRetribution.unit_type }}
          </div>
        </div>
      </div>
    </td>
    <td style="width: 15%">
      <div class="form-group mb-0">
        <input
          class="form-control number-form text-right"
          type="text"
          min="0"
          placeholder="eg. Masukkan Jumlah"
          v-currency="currencyMask"
          v-model="objectRetribution.amount"
          :disabled="loading"
        />
      </div>
    </td>

    <td style="width: 25%">
      <div class="input-group">
        <input
          class="form-control text-right"
          type="text"
          v-currency="currencyMask"
          :value="objectRetribution.total"
          readonly
        />

        <input
          class="form-control text-right"
          type="number"
          v-show="false"
          readonly
          v-model="objectRetribution.total"
          :disabled="loading"
        />
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: [
    "dataObjectRetribution",
    "dataService",
    "index",
    "loading",
    "validationItter",
  ],
  data() {
    return {
      // SET IF PRICE IS EDITABLE
      editablePrice: false,

      selectedPrice: 0,

      objectRetribution: {
        index: this.index,
        id: "",
        price: 0,
        amount: 1,
        unit: 1,
        unit_type: null,
        total: 0,
      },
    };
  },
  computed: {
    // SET BUTTON COLOR ON DELETE BUTTON
    classButton() {
      if (this.companyType == "HEALTH_CARE") {
        return "btn-danger";
      } else {
        return this.dataObjectRetribution.length > 1
          ? "btn-danger"
          : "btn-info";
      }
    },
  },
  methods: {
    disabledDelete() {
      if (this.companyType == "HEALTH_CARE") {
        return false;
      } else {
        return this.dataObjectRetribution.length <= 1;
      }
    },
    // REMOVE SERVICE $EMIT
    removeService() {
      this.$emit("handleRemove", this.objectRetribution.index);
    },
    // SET VALUE $EMIT
    setValue() {
      this.$emit("handleData", {
        index: this.objectRetribution.index,
        id: this.objectRetribution.id,
        price: this.reInteger(this.objectRetribution.price),
        unit: parseInt(this.objectRetribution.unit),
        unit_type: this.objectRetribution.unit_type,
        amount: this.reInteger(this.objectRetribution.amount),
        total: this.reInteger(this.objectRetribution.total),
      });
    },
  },
  watch: {
    // WATCH EVERY CHANGE ON ID
    "objectRetribution.id": {
      handler(val) {
        const self = this;

        const service = this.dataService;
        let getServiceDetail = service.find((item) => {
          return item.id == this.objectRetribution.id;
        });

        let selectedEditable = false;
        if (getServiceDetail) {
          this.selectedPrice = getServiceDetail.price;
          this.editablePrice = getServiceDetail.is_editable_price;
        }

        const objectRetribution = this.objectRetribution;

        if (objectRetribution.id && objectRetribution.amount > 0) {
          objectRetribution.price = this.selectedPrice;
          this.objectRetribution.unit = getServiceDetail.unit;
          this.objectRetribution.unit_type = getServiceDetail.unit_type;
          objectRetribution.total = (function () {
            if (getServiceDetail.unit) {
              const pricePerUnit = self.selectedPrice / getServiceDetail.unit;
              return objectRetribution.amount * pricePerUnit;
            } else {
              return objectRetribution.amount * self.selectedPrice;
            }
          })();
        }

        this.setValue();
      },
    },
    // WATCH EVERY CHANGE ON PRICE
    "objectRetribution.price": {
      handler(val) {
        const self = this;
        const objectRetribution = this.objectRetribution;
        objectRetribution.total = (function () {
          if (objectRetribution.unit) {
            const pricePerUnit =
              self.reInteger(objectRetribution.price) /
              self.reInteger(objectRetribution.unit);
            return (
              self.reInteger(objectRetribution.amount) *
              self.reInteger(pricePerUnit)
            );
          } else {
            return (
              self.reInteger(objectRetribution.amount) *
              self.reInteger(objectRetribution.price)
            );
          }
        })();
        this.setValue();
      },
    },
    // WATCH EVERY CHANGE ON AMOUNT
    "objectRetribution.amount": {
      handler(val) {
        const self = this;
        const objectRetribution = this.objectRetribution;
        objectRetribution.total = (function () {
          if (objectRetribution.unit) {
            const pricePerUnit =
              self.reInteger(objectRetribution.price) /
              self.reInteger(objectRetribution.unit);
            return (
              self.reInteger(objectRetribution.amount) *
              self.reInteger(pricePerUnit)
            );
          } else {
            return (
              self.reInteger(objectRetribution.amount) *
              self.reInteger(objectRetribution.price)
            );
          }
        })();
        this.setValue();
      },
    },
  },
  mounted() {
    const self = this;

    this.objectRetribution = {
      index: this.index,
      id: this.dataObjectRetribution[this.index].id,
      price: this.dataObjectRetribution[this.index].price,
      amount: this.dataObjectRetribution[this.index].amount,
      unit: this.dataObjectRetribution[this.index].unit,
      unit_type: this.dataObjectRetribution[this.index].unit_type,
      total: this.dataObjectRetribution[this.index].total,
    };

    setTimeout(() => {
      $(".select-2-custom-form").select2();
    }, 10);

    // FORCE NUMBER FORM DEFAULT VALUE TO 1
    $(".number-form").blur(function () {
      if ($(this).val() == "" || $(this).val() < 1) {
        self.objectRetribution.amount = 1;
      }
    });
  },
};
</script>

<style>
</style>